import { Button } from "@/components/ui/button"
import {
    CardContent
} from "@/components/ui/card"
import { Avatar, AvatarImage } from "@radix-ui/react-avatar"
import { useState } from "react";
import TransactionForm from "./TransactionForm";


export default function TransactionList(user: any) {

    const [currentTrans, setCurrentTrans] = useState<any>();

    const recentSales = [
        {
            "name": "Ava Davis",
            "email": "ava.davis@email.com",
            "avatar": "/avatars/03.png",
            "fallback": "AD",
            "totalSales": {
                "total": 100,
                "amount": 1000
            }
        },
        {
            "name": "Sophia Brown",
            "email": "sophia.brown@email.com",
            "avatar": "/avatars/04.png",
            "fallback": "SB",
            "totalSales": {
                "total": 100,
                "amount": 1000
            }
        },
        {
            "name": "Isabella Wilson",
            "email": "isabella.wilson@email.com",
            "avatar": "/avatars/03.png",
            "fallback": "IW",
            "totalSales": {
                "total": 100,
                "amount": 900
            }
        },
        {
            "name": "Mia Moore",
            "email": "mia.moore@email.com",
            "avatar": "/avatars/02.png",
            "fallback": "MM",
            "totalSales": {
                "total": 100,
                "amount": 800
            }
        },
        {
            "name": "Harper Anderson",
            "email": "harper.anderson@email.com",
            "avatar": "/avatars/01.png",
            "fallback": "HA",
            "totalSales": {
                "total": 100,
                "amount": 1200
            }
        },
        {
            "name": "Evelyn Thomas",
            "email": "evelyn.thomas@email.com",
            "avatar": "/avatars/01.png",
            "fallback": "ET",
            "totalSalesAmount": "+$1,999.00"
        },
        {
            "name": "Amelia Taylor",
            "email": "amelia.taylor@email.com",
            "avatar": "/avatars/02.png",
            "fallback": "AT",
            "totalSales": {
                "total": 100,
                "amount": 3000
            }
        },
    ];

    return (
        <>
        <CardContent className="grid gap-8">
                {Boolean(!currentTrans) && (
                    <>
                        {recentSales.map((sale: any, index: number) => (
                            <div key={sale.email} className="flex items-center gap-4">
                                <Avatar className="hidden h-9 w-9 sm:flex">
                                    <AvatarImage src={sale.avatar} alt="Avatar" />
                                </Avatar>
                                <div className="grid gap-1">
                                    <p className="text-sm font-medium leading-none">{sale.name}</p>
                                    <p className="text-sm text-muted-foreground">{sale.email}</p>
                                </div>
                                <div className="ml-auto font-medium">{sale.totalSales?.amount}</div>
                                <div>
                                    <Button size="sm" onClick={() => {
                                        console.log('View Sale', sale.totalSales.amount)
                                        setCurrentTrans(sale)
                                    }}>
                                        Edit
                                    </Button>
                                </div>
                            </div>
                        ))}
                    </>
                )}

                {Boolean(currentTrans) && (
                    <TransactionForm transaction={currentTrans} setOpen={() => setCurrentTrans(undefined)} />
                )}


            </CardContent>
        </>
    );
}